/**
 * Profile stats row (specs/profile-page AC-9, AC-10): a single row of four equal tiles —
 * Played / Won / Win rate / Streak. Values are pre-derived by profileStats.helper.
 */

import React from 'react';
import { View, Text } from 'react-native';
import type { ProfileStatTile } from '../../helpers/profileStats.helper';
import { PROFILE_COLORS, PROFILE_TEST_IDS } from '../ProfileScreen/ProfileScreen.constants';
import { profileStatsRowStyles as styles } from './ProfileStatsRow.styles';

const TEST_ID_BY_KEY: Record<ProfileStatTile['key'], string> = {
  played: PROFILE_TEST_IDS.statPlayed,
  won: PROFILE_TEST_IDS.statWon,
  winRate: PROFILE_TEST_IDS.statWinRate,
  streak: PROFILE_TEST_IDS.statStreak,
};

/** "Won" gets the mint accent to echo the design; the rest use the default text colour. */
const VALUE_COLOR_BY_KEY: Partial<Record<ProfileStatTile['key'], string>> = {
  won: PROFILE_COLORS.mint,
};

export interface ProfileStatsRowProps {
  tiles: ProfileStatTile[];
  testID?: string;
}

export const ProfileStatsRow: React.FC<ProfileStatsRowProps> = ({ tiles, testID }) => (
  <View style={styles.row} testID={testID}>
    {tiles.map((tile) => (
      <View key={tile.key} style={styles.tile} testID={TEST_ID_BY_KEY[tile.key]}>
        <Text style={[styles.value, VALUE_COLOR_BY_KEY[tile.key] ? { color: VALUE_COLOR_BY_KEY[tile.key] } : null]}>
          {tile.value}
        </Text>
        <Text style={styles.label}>{tile.label}</Text>
      </View>
    ))}
  </View>
);
